import { useQuery } from '@apollo/client';
import { aftermarketPartnerApi } from '../api';
import {
  PartnersOwnProposalsWithPaginationResponse,
  PartnersProposalsWithPaginationResponse,
  ProposalsTableDataWithPaginationVariables,
} from '../api/types';
import { ProposalsPageButtonGroupOptions } from '../types';

export function useFetchProposals(accountId: string, viewTab: ProposalsPageButtonGroupOptions, fetchVariables: any) {
  const {
    data: partnerProposalsData,
    previousData: partnerProposalsPreviousData,
    loading: isPartnerProposalsDataLoading,
  } = useQuery<PartnersProposalsWithPaginationResponse, ProposalsTableDataWithPaginationVariables>(
    aftermarketPartnerApi.getPartnersProposalsWithPagination,
    {
      skip: viewTab !== ProposalsPageButtonGroupOptions.DealerProposals,
      notifyOnNetworkStatusChange: false,
      variables: { input: { accountId, ...fetchVariables } },
    }
  );

  const {
    data: partnerOwnProposalsData,
    previousData: partnerOwnProposalsPreviousData,
    loading: isPartnerOwnProposalsDataLoading,
  } = useQuery<PartnersOwnProposalsWithPaginationResponse, ProposalsTableDataWithPaginationVariables>(
    aftermarketPartnerApi.getPartnersOwnProposalsWithPagination,
    {
      skip: viewTab !== ProposalsPageButtonGroupOptions.YourProposals,
      notifyOnNetworkStatusChange: false,
      variables: { input: { accountId, ...fetchVariables } },
    }
  );

  const isLoading = isPartnerProposalsDataLoading || isPartnerOwnProposalsDataLoading;
  const proposals =
    viewTab === ProposalsPageButtonGroupOptions.DealerProposals
      ? (partnerProposalsData?.partnersProposalsWithPagination?.data ??
        partnerProposalsPreviousData?.partnersProposalsWithPagination?.data)
      : (partnerOwnProposalsData?.partnersOwnProposalsWithPagination?.data ??
        partnerOwnProposalsPreviousData?.partnersOwnProposalsWithPagination?.data);

  const total =
    viewTab === ProposalsPageButtonGroupOptions.DealerProposals
      ? (partnerProposalsData?.partnersProposalsWithPagination?.total ??
        partnerProposalsPreviousData?.partnersProposalsWithPagination?.total)
      : (partnerOwnProposalsData?.partnersOwnProposalsWithPagination?.total ??
        partnerOwnProposalsPreviousData?.partnersOwnProposalsWithPagination?.total);

  return {
    isLoading,
    proposals: proposals ?? [],
    total: total ?? 0,
  };
}
